import { useSelector } from "react-redux";

import { getDomainCountryCode } from "redux/selectors/config";

const NoDealsOrPromos: React.FC<{
  type: "deals" | "promotions";
}> = ({ type }) => {
  const countryCode = useSelector(getDomainCountryCode);

  return (
    <div className="my-xxl">
      This {countryCode === "CA" ? "store" : "dispensary"} isn’t sharing any
      {` ${type}`} right now. Check back later!
    </div>
  );
};

export default NoDealsOrPromos;
